import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-dependencies',
  templateUrl: './dependencies.component.html',
  styleUrls: ['./dependencies.component.scss']
})
export class DependenciesComponent  {

  constructor( private translateService: TranslocoService
  ) { }

 getEmailText(translationString:string) : string{
    return "mailto:"+this.translateService.translate(translationString)
  }

}


